module.exports = __webpack_public_path__ + "img/facebook.7c8d991e.png";